// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"72f13bac","455":"b3f8d061","977":"969c545c"}[chunkId] + ".chunk.js";
};